import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const MAX_VISIBLE = 3;

const messages = [
  { from: 'user', text: 'Olá, está aberto hoje?' },
  { from: 'bot', text: 'Olá! Sim, estamos abertos até as 22h. Nosso buffet livre custa R$ 49,90/pessoa.' },
  { from: 'user', text: 'Tem opção vegetariana?' },
  { from: 'bot', text: 'Sim. Temos grande variedade de pratos veganos e vegetarianos.' },
  { from: 'user', text: 'Qual o endereço?' },
  { from: 'bot', text: 'Rua das Flores, 123 — a 5 min do centro.' },
];

function ChatBubble({ from, text }) {
  const isBot = from === 'bot';
  return (
    <div className={`flex w-full ${isBot ? 'justify-start' : 'justify-end'}`}>
      {isBot && (
        <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center shrink-0 mr-2 mt-0.5">
          <span className="material-symbols-outlined text-primary text-[12px]">smart_toy</span>
        </div>
      )}
      <div
        className={`max-w-[78%] px-3 py-2 rounded-2xl text-xs leading-relaxed shadow-sm ${isBot
            ? 'bg-white/[.08] text-white/85 rounded-tl-sm'
            : 'bg-primary/90 text-white rounded-tr-sm'
          }`}
      >
        {text}
      </div>
    </div>
  );
}

export function ChatDemoCard() {
  // cursor into the messages array; loops back to 0 after finishing
  const [cursor, setCursor] = useState(0);
  // window of indices currently visible
  const [window, setWindow] = useState([0]);

  useEffect(() => {
    const current = messages[cursor];
    // user "thinks" a bit, bot replies faster
    const delay = current.from === 'user' ? 1000 : 1600;

    const t = setTimeout(() => {
      const next = (cursor + 1) % messages.length;
      setCursor(next);
      setWindow((prev) => {
        const updated = [...prev, next];
        // keep only the last MAX_VISIBLE
        return updated.slice(-MAX_VISIBLE);
      });
    }, delay);

    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cursor]);

  // reset loop smoothly: fade all out briefly then restart
  const visibleMessages = window.map((idx) => ({ idx, ...messages[idx] }));

  return (
    <div className="absolute inset-0 flex flex-col justify-center overflow-hidden px-4 py-6 gap-2">
      <AnimatePresence initial={false}>
        {visibleMessages.map(({ idx, from, text }) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: -14, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 14, scale: 0.94 }}
            transition={{ type: 'spring', stiffness: 340, damping: 38 }}
          >
            <ChatBubble from={from} text={text} />
          </motion.div>
        ))}
      </AnimatePresence>

      {/* Typing indicator: show before bot's next reply */}
      {messages[(cursor + 1) % messages.length].from === 'bot' && (
        <motion.div
          key={`typing-${cursor}`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="flex items-center gap-1.5 ml-8"
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-1.5 h-1.5 rounded-full bg-primary/50 animate-bounce"
              style={{ animationDelay: `${i * 150}ms`, animationDuration: '800ms' }}
            />
          ))}
        </motion.div>
      )}
    </div>
  );
}
